import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class CanonicalService {
  constructor(private meta: Meta) {}

  setCanonicalURL(url?: string) {
    const canonicalUrl = url || window.location.href;

    let link: HTMLLinkElement | null =
      document.querySelector("link[rel='canonical']");

    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }

    link.setAttribute('href', canonicalUrl);
    // console.log('Canonical set to:', canonicalUrl);
  }
}
